import React from 'react';
import { Box, Button, CheckCircleIcon, DownloadIcon, Text } from '@razorpay/blade/components';

export const FileDownloadButton = ({
  fileDownloaded,
  setFileDownloaded,
  disabled,
  href,
  buttonText,
  onClick,
}: {
  fileDownloaded?: boolean;
  setFileDownloaded?: (fileDownloaded: boolean) => void;
  disabled?: boolean;
  href: string;
  buttonText?: string;
  onClick?: () => void;
}) => {
  function onClickFunction() {
    setFileDownloaded && setFileDownloaded(true);
    onClick && onClick();
  }

  return (
    <Box>
      <Button
        href={href}
        onClick={onClickFunction}
        target="_blank"
        variant="secondary"
        size="small"
        isDisabled={disabled}
        icon={DownloadIcon}
        iconPosition="left">
        {buttonText ? buttonText : 'Download Now'}
      </Button>
      {Boolean(fileDownloaded) && (
        <Box display="flex" alignItems="center" gap="spacing.2" marginTop="spacing.5">
          <CheckCircleIcon color="interactive.icon.positive.subtle" />
          <Text color="interactive.text.positive.subtle">File downloaded successfully!</Text>
        </Box>
      )}
    </Box>
  );
};
